import logoInstagram from '../assets/instagram.png';
import localizacao from '../assets/localizacao.png';
import logoWhatsapp from '../assets/whatsapp.png';
import cardapioDigital from '../assets/cardapio-digital.png';

export const dataBase = [
    {
        id: 1,
        mediaLogo: logoInstagram,
        mediaName: 'INSTAGRAM',
        mediaLink: 'https://www.instagram.com/xocalosorveteria/'
    },
    {
        id: 2,
        mediaLogo: logoWhatsapp,
        mediaName: 'WHATSAPP',
        mediaLink: 'https://api.whatsapp.com/send?phone=5575992331912'
    },
    {
        id: 3,
        mediaLogo: cardapioDigital,
        mediaName: 'CARDÁPIO DIGITAL',
        mediaLink: 'https://drive.google.com/file/d/1poHVChvggtFAAwx4oR4dg3Cesl9amDmD/view?usp=share_link'
    },
    {
        id: 4,
        mediaLogo: localizacao,
        mediaName: 'LOCALIZAÇÃO',
        mediaLink: 'https://goo.gl/maps/WZQKMdv9T26suBAk8'
    },
]
